/* How the agent reads a knowledge file, so the Indexed view shows exactly that. Mirrors
   `backend/modules/knowledge/tools/text.py`: a file up to BODY_CAP is read whole; a longer one
   with `##` headings answers with its opening and its sections, each fetched on demand; a
   longer one without them is cut at BODY_CAP and the agent is told so. Lengths count
   characters (code points), as Python's `len` does. */

export const BODY_CAP = 40_000;
const PREAMBLE_CAP = 4_000;
/* Exactly two #s, as `split(level=2)`: `###` rides with its parent section. */
const SECTION = /^#{2}\s+(.+?)\s*$/gm;

export interface Section { title: string; chars: number; text: string }

export type ReadPlan =
  | { kind: "whole"; chars: number }
  | { kind: "sections"; chars: number; opening: string; sections: Section[] }
  | { kind: "cut"; chars: number; over: number };

const length = (text: string) => [...text].length;

export function readPlan(text: string): ReadPlan {
  const chars = length(text);
  if (chars <= BODY_CAP) return { kind: "whole", chars };
  const marks = [...text.matchAll(SECTION)];
  if (!marks.length) return { kind: "cut", chars, over: chars - BODY_CAP };
  const edges = [...marks.map((m) => m.index!), text.length];
  const sections = marks.map((m, i) => {
    const body = text.slice(edges[i], edges[i + 1]).trimEnd();
    return { title: m[1], chars: length(body), text: body };
  });
  return { kind: "sections", chars, opening: [...text.slice(0, edges[0])].slice(0, PREAMBLE_CAP).join("").trimEnd(), sections };
}
